@for (filterValue of filterValues(); track filterValue?.value) {
<base-checkbox-filter [isChecked]="filterValue?.checked || false" [type]="type() || 'checkbox'" (checked)="selectFilter(filterValue)" [label]="filterValue?.value || '' | titlecase" [doc_count]="filterValue?.doc_count || 0">
    <ng-content></ng-content>
</base-checkbox-filter>
}